import React from 'react';
import ReactPlayer from 'react-player';

const Vimeo = () => {
  return <ReactPlayer controls={true} url='https://vimeo.com/90509568' />;
};

export default Vimeo;
